import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { useMe } from "../lib/me";

const LINKS = [
  { to: "/", label: "Lobby", id: "lobby", end: true },
  { to: "/lesson", label: "Lesson Room", id: "lesson-room" },
  { to: "/library", label: "Library", id: "library" },
  { to: "/chords", label: "Chords", id: "chords" },
  { to: "/plans", label: "Lesson Plans", id: "plans" },
  { to: "/purchases", label: "My Purchases", id: "purchases" },
];
const ADMIN = [
  { to: "/admin/sales", label: "Sales", id: "sales" },
  { to: "/admin/users", label: "Users", id: "users" },
];

const Links = ({ onClick, prefix }) => {
  const { isAdmin } = useMe();
  return [...LINKS, ...(isAdmin ? ADMIN : [])].map((l) => (
    <NavLink
      key={l.to}
      to={l.to}
      end={l.end}
      onClick={onClick}
      data-testid={`${prefix}-${l.id}`}
      className={({ isActive }) =>
        `px-3 py-2 text-sm rounded-[3px] transition-colors ${isActive ? "text-yellow-300 bg-yellow-400/10" : "text-zinc-400 hover:text-white"}`
      }
    >
      {l.label}
    </NavLink>
  ));
};

export const Layout = () => {
  const { me } = useMe();
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen grain">
      <header className="sticky top-0 z-40 border-b border-[#2d2d38] bg-[#0a0a0c]/85 backdrop-blur-xl">
        <div className="mx-auto flex h-14 max-w-[1600px] items-center gap-4 px-4 md:px-6">
          <NavLink to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <span className="grid h-7 w-7 place-items-center rounded-[3px] bg-yellow-400 text-black font-black">B</span>
            <span className="font-black tracking-tight text-lg">BANDCAMP</span>
          </NavLink>
          <nav className="hidden lg:flex items-center gap-1 ml-4"><Links prefix="nav-link" /></nav>
          <div className="ml-auto flex items-center gap-3">
            <span className="hidden sm:inline mono-label" data-testid="nav-role-badge">
              {me.role}{me.is_member && me.role === "student" ? " · member" : ""}
            </span>
            <UserButton />
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger className="lg:hidden p-2 text-zinc-300" data-testid="nav-mobile-menu-btn"><Menu className="h-5 w-5" /></SheetTrigger>
              <SheetContent side="right" className="bg-[#0a0a0c] border-[#2d2d38] flex flex-col gap-1 pt-12">
                <Links prefix="nav-mobile" onClick={() => setOpen(false)} />
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </header>
      <main><Outlet /></main>
    </div>
  );
};
